export default __webpack_public_path__ + "static/media/partnerCoupon.c1fd0383.png";